export class UseConditions {
    id: number;
    code:string;
    description: string;
    disabled: boolean    
} 